export type DevelopmentBuilds = "development" | "e2";
export type ProductionBuilds = "online" | "onlineSelective" | "e2";
export type Stages = "staging" | "stage1" | "stage2" | "stage3" | "stage4";

export type GameType = {
    name: string;
    id: string;
    originalId?: string;  //don't use if you don't fully understand, it's a special case for old gs
    staging: DevelopmentBuilds | ProductionBuilds;
    stage1: ProductionBuilds;
    stage2: ProductionBuilds;
    stage3: ProductionBuilds;
    stage4: ProductionBuilds
}
export type GameListType = GameType[]

export const GameList: GameListType = [
    {
        name: "Ancient_Secret_Dice",
        id: "00132c71-3b86-437c-8fce-fa2f378ecd87",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Continent_Africa",
        id: "b6000552-c396-11e6-a4a6-cec0c932ce01",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Dragons_Power",
        id: "b7102f34-5c7e-44b8-a2b2-98d281cf87dc",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Dragons_Power_Asia",
        id: "55e0e4f7-3e61-4c86-a09a-89cc5ce815d2",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Energy_Fruits_Dice",
        id: "a719ac2c-d970-40d5-9a53-b42c97ddd917",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fresh_Fortune",
        id: "b793d8a9-0da9-485d-a35d-c156057f6c61",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fruitastic",
        id: "1f6195e5-ad0b-44e8-9cac-611b2bdc9628",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golden_Lamp",
        id: "2de0237d-6559-4697-b9ee-464335a4989b",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golden_New_World",
        id: "1057aa1b-2b26-4d11-80d9-d99fa8c2fd23",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Gold_of_Ming",
        id: "7eeb0c88-5f32-4be9-aa78-ffb713845017",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Gold_of_Ming_Asia",
        id: "6ea1efbc-7aab-4a66-8407-59d144527662",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Jazz_Spin",
        id: "b5c841ac-435b-4860-966c-f48873e74209",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Koi_Kingdom",
        id: "9b1426c1-da1b-4d0c-a6e9-4a704d4c4602",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Koi_Kingdom_Asia",
        id: "2f8acd53-9626-44d8-92ae-27ea3bd48454",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Magic_Hunter",
        id: "21c67359-14f0-424a-aabf-acc0a1a280f5",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Mad_Men_and_Nuclear_War",
        id: "b5ff2179-32d2-4c10-9939-2087edf70285",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Magic_Queens",
        id: "b549846a-588b-11e6-8b77-86f30ca893d3",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Magic_Queens_Dice",
        id: "3db7ec4a-cdfc-4422-b1c7-4b405b096595",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Best_New_York_Food",
        id: "1d4d0dc8-9f7d-11e7-abc4-cec278b6b50a",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Ocean_Reef",
        id: "f2262c26-213f-4ee9-aadc-8fe7cb8228c1",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Pharaohs_and_Aliens",
        id: "7d2988eb-8f74-42fa-b8de-aaaaaaaaaaaa",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Pagoda_of_Fortune",
        id: "500e6195-2b7f-4ac4-94c1-91c8cfc3a6ae",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Pagoda_of_Fortune_Asia",
        id: "ebc59eb7-c055-4962-80ae-cc377f878ee6",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Pyramid_Treasure_Dice",
        id: "d9c4175e-6d82-49ec-be43-58bde4b56f43",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Royal_Crown",
        id: "21ba0eb8-3aa1-46a3-9772-212fb9f96058",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Royal_Crown_Dice",
        id: "9079ba4d-8fa3-4224-87f1-9f943d816d2e",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Royal_Win_Dice",
        id: "royal-win-dice",
        staging: "e2",
        stage1: "e2",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Riches_from_the_Deep",
        id: "e1b75305-48ef-4f53-8787-db903a3d51e9",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Rich_Castle",
        id: "6c3f624b-f839-4aa7-93bf-a7ff5eaa3a5e",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    }, {
        name: "Steampunk_Big_City",
        id: "d3e0f46a-35aa-4823-aeb3-c1647751affb",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Star_Fortune",
        id: "ae926d3d-988e-4d57-8b71-4ee188d7e03c",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Star_Fortune_Dice",
        id: "caf1bcb7-020d-431c-9ab6-97bf9b94f594",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Dice",
        id: "6e7e12cc-a9f6-4c25-b3e6-a017d0ceba44",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_20_Deluxe_Dice",
        id: "9e1936a7-cd05-4559-afc6-85639955e903",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning27_Dice",
        id: "079f8995-8fd4-4678-9a67-23610bb17172",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Tequila_Fiesta",
        id: "a4508224-3475-11e6-ac61-9e71128cae77",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Voodoo_Candy_Shop_Dice",
        id: "542a0952-a7ce-4ccd-abeb-dbc4a3a6abc4",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Voodoo_Candy_Shop_Deluxe",
        id: "ebdbad5d-acef-4329-a22c-3da2aef0a2ec",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Vintage_Win",
        id: "09e5a92c-e58b-459b-b091-cf2586f9daba",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Wild_Jack_Dice",
        id: "49170ce8-8839-418c-8cb6-9d1ac5360701",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Aztec_Adventure",
        id: "aztec-adventure",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Bonnie_and_Clyde",
        id: "bonnie-and-clyde",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Gods_2",
        id: "book-of-gods",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Gates",
        id: "book-of-gates",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cold_As_Ice",
        id: "5f28f820-622c-4396-8cf3-67a18fd54d97",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cosmic_Dream",
        id: "cosmic-dream",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Crystal_Mania",
        id: "crystal-mania",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Disco_Lights",
        id: "disco-lights",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fibonacci",
        id: "fibonacci",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Hot_Classic",
        id: "hot-classic",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Hot_Sunrise",
        id: "hot-sunrise",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Lucky_Symbols",
        id: "lucky-symbols",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Lucky_Tropics",
        id: "lucky-tropics",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Ramses_Rising",
        id: "ramses-rising",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Road_2_Cash",
        id: "road-2-cash",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Taste_of_China",
        id: "taste-of-china",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Star_Settler",
        id: "star-settler",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Remastered",
        id: "stunning-hot-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Deluxe_Remastered",
        id: "stunning-hot-20-deluxe-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Royal_Win_Remastered",
        id: "royal-win-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Snow_Remastered",
        id: "stunning-snow-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Cube",
        id: "stunning-cube",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_27_Remastered",
        id: "stunning-27-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cave_of_Fortune",
        id: "cave-of-fortune",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Wild_Jack_Remastered",
        id: "wild-jack-remastered",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Buffalo_Trail",
        id: "buffalo-trail",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Buffalo_Trail_lite",
        id: "buffalo-trail-lite",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Buffalo_Trail_Ultra",
        id: "buffalo-trail-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots",
        id: "burning-slots",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Squid_From_The_Deep",
        id: "squid-from-the-deep",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Chicken_Madness",
        id: "chicken-madness",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cave_of_Gold",
        id: "cave-of-gold",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_20",
        id: "burning-slots-20",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_40",
        id: "burning-slots-40",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_100",
        id: "burning-slots-100",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Cash",
        id: "stunning-cash",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Cash_Ultra",
        id: "stunning-cash-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Lucky_Ticket_81",
        id: "lucky-ticket-81",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cave_of_Xmas",
        id: "cave-of-xmas",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Chicken_Madness_Ultra",
        id: "chicken-madness-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Dragons_Chance",
        id: "dragons-chance",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Sweet_Reward",
        id: "sweet-reward",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Cash_Mesh",
        id: "burning-slots-cash-mesh",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Energy_Fruits",
        id: "fd7b3f92-9d06-47e2-83b9-2b4f8377b06b",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Energy_Stars",
        id: "ed87112d-67f9-4896-9e37-f06f84715280",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot",
        id: "aa827330-f395-41bc-98fa-9626dfb24f8b",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Horizon_Hunters",
        id: "horizon-hunters",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots",
        id: "fiery-slots",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown",
        id: "stunning-crown",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_100",
        id: "stunning-crown-100",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "FK_Zalgiris_Legacy",
        id: "stunning-crown-betsafelt",
        originalId: "stunning-crown",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Alice_In_Wonderland",
        id: "93823fdf-d73e-4f9d-9eeb-06568bbba31e",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Rome_Warrior",
        id: "cd0c9f9c-e61f-4e80-82ef-673660e7e155",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_27",
        id: "8398353d-a1ac-48d4-8fb5-12043c424c74",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Joker_Spin",
        id: "c501bc3c-c11e-11e6-a4a6-cec0c932ce01",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Deluxe",
        id: "8c7ce246-6bda-4b36-bead-e2a2b7cf955d",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Snow",
        id: "8af8c41e-b88e-11e7-abc4-cec278b6b50a",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Legacy_of_Tombs",
        id: "legacy-of-tombs",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Ming",
        id: "ea15b0a6-8fc6-4b5d-a59a-698e10a1d5fa",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Transylvanian_Beauty",
        id: "60efc7e8-8293-40d6-9131-2dbf367ea6f8",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Cash_Mesh_Ultra",
        id: "fiery-slots-cash-mesh-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Cash_Mesh_Ultra_Dice",
        id: "fiery-slots-cash-mesh-ultra-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Dice",
        id: "burning-slots-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Wild_Jack",
        id: "bb50719b-1a3f-4c85-805d-8e782c30a615",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Wisdom",
        id: "book-of-wisdom",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Royal_Win",
        id: "royal-win",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Ancient_Secrets",
        id: "71331e1b-c051-4ab7-a2a4-b04a392dd16f",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Dark_Carnivale",
        id: "ccc5fa65-b8a9-4811-aad7-8f2de43edd06",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_20_Dice",
        id: "burning-slots-20-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Megacity",
        id: "megacity",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Dice",
        id: "fiery-slots-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Voodoo_Candy_Shop",
        id: "59d7c3d8-c526-4bd8-8e10-6bae1022f725",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Jewels_World",
        id: "6db69af3-1a29-4849-b6af-c7c4b7d18243",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Pyramid_Treasure",
        id: "72e661ee-481c-11e6-beb8-9e71128cae77",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "El_Dorado_Totems",
        id: "el-dorado-totems",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Hot_Classic_Dice",
        id: "hot-classic-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Frozen_Yeti",
        id: "frozen-yeti",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_Cash_Mesh",
        id: "stunning-crown-cash-mesh",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_Cash_Mesh_Ultra",
        id: "stunning-crown-cash-mesh-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Raiders_of_the_North",
        id: "raiders-of-the-north",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Cash_Mesh_Ultra",
        id: "burning-slots-cash-mesh-ultra",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Megacity_Football_Fever",
        id: "megacity-football-fever",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golden_Chance",
        id: "8d0bb328-0d40-4fb4-a98e-b8a9c58c4dcf",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Dark_Carnivale_Dice",
        id: "dark-carnivale-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Alice_In_Wonderland_Dice",
        id: "alice-in-wonderland-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_Dice",
        id: "stunning-crown-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golem_Wildwoods",
        id: "golem-wildwoods",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Mr_First_Sweet_Reward",
        id: "mr-first-sweet-reward",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Cave_of_Gems",
        id: "cave-of-gems",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_100_dice",
        id: "burning-slots-100-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "El_Dorado_Totems_Dice",
        id: "el-dorado-totems-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Rome_Warrior_Dice",
        id: "rome-warrior-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Lucky_Symbols_Dice",
        id: "lucky-symbols-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "_1Win_Crown",
        id: "1win-crown",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    //book of gods is still used in one casino, it should be probably deleted soon:
    //https://beefee.slack.com/archives/C9TH0DVTQ/p1743000792037079
    {
        name: "Book_of_Gods",
        id: "b7d0cfb2-e92e-43db-b2aa-267056a82ee0",
        staging: "e2",
        stage1: "e2",
        stage2: "e2",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Cash_Mesh_Dice",
        id: "burning-slots-cash-mesh-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null
    },
    {
        name: "_777_Golden_Hit",
        id: "777-golden-hit",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "_777_Winter_Hit",
        id: "777-winter-hit",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Blasting_Rubies",
        id: "blasting-rubies",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Snow_Remastered_Dice",
        id: "stunning-snow-remastered-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Frozen_Yeti_Dice",
        id: "frozen-yeti-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Raiders_of_the_North_Social_Casino",
        id: "raiders-of-the-north-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Gods_2_Social_Casino",
        id: "book-of-gods-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Wisdom_Social_Casino",
        id: "book-of-wisdom-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_100_Social_Casino",
        id: "burning-slots-100-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "El_Dorado_Totems_Social_Casino",
        id: "el-dorado-totems-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Social_Casino",
        id: "fiery-slots-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Frozen_Yeti_Social_Casino",
        id: "frozen-yeti-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Horizon_Hunters_Social_Casino",
        id: "horizon-hunters-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Legacy_of_Tombs_Social_Casino",
        id: "legacy-of-tombs-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Lucky_Symbols_Social_Casino",
        id: "lucky-symbols-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Megacity_Football_Fever_Social_Casino",
        id: "megacity-football-fever-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Ramses_Rising_Social_Casino",
        id: "ramses-rising-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_Social_Casino",
        id: "stunning-crown-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Social_Casino",
        id: "stunning-hot-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Hot_Deluxe_Social_Casino",
        id: "stunning-hot-20-deluxe-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Sweet_Reward_Social_Casino",
        id: "sweet-reward-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Cave_of_Gems_Social_Casino",
        id: "cave-of-gems-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Dragons_Chance_Social_Casino",
        id: "dragons-chance-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Jewels_World_Social_Casino",
        id: "jewels-world-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Rome_Warrior_Social_Casino",
        id: "rome-warrior-social",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Burlesque_Show",
        id: "burlesque-show",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golem_Mystery_Wilds",
        id: "golem-mystery-wilds",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_PepperMill_Dice",
        id: "stunning-peppermill-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Cash_Mesh",
        id: "fiery-slots-cash-mesh",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Cash_Mesh_Ultra_Dice",
        id: "burning-slots-cash-mesh-ultra-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Summer_Bling",
        id: "summer-bling",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Diamond_Bling",
        id: "diamond-bling",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Golem_Wildwoods_Dice",
        id: "golem-wildwoods-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Book_of_Gods_2_Dice",
        id: "book-of-gods-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Werewolf_Hour",
        id: "werewolf-hour",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Jokers_Vault",
        id: "jokers-vault",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Jokers_Vault_Dice",
        id: "jokers-vault-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Road_2_Cash_Dice",
        id: "road-2-cash-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Classic_Xtreme",
        id: "classic-xtreme",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Chicken_Madness_Dice",
        id: "chicken-madness-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Buffalo_Trail_Dice",
        id: "buffalo-trail-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Magnetic_Coins",
        id: "magnetic-coins",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Dopamine_Rush",
        id: "dopamine-rush",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Burning_Slots_Cash_Mesh_Power_Edition",
        id: "burning-slots-cash-mesh-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Crown_Cash_Mesh_Power_Edition",
        id: "stunning-crown-cash-mesh-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Stunning_Cash_Power_Edition",
        id: "stunning-cash-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Chicken_Madness_Power_Edition",
        id: "chicken-madness-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Fiery_Slots_Cash_Mesh_Power_Edition",
        id: "fiery-slots-cash-mesh-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "Buffalo_Trail_Power_Edition",
        id: "buffalo-trail-15k",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "_777_Summer_Hit",
        id: "777-summer-hit",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Ruby_Joker",
        id: "ruby-joker",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Blasting_Rubies_Dice",
        id: "blasting-rubies-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Heart_of_1Win",
        id: "heart-of-1win",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "_777_Golden_Hit_Dice",
        id: "777-golden-hit-dice",
        staging: "onlineSelective",
        stage1: "onlineSelective",
        stage2: "onlineSelective",
        stage3: null,
        stage4: null,
    },
    {
        name: "Acropolis_Fortune",
        id: "acropolis-fortune",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
    {
        name: "_777_Spooky_Hit",
        id: "777-spooky-hit",
        staging: "development",
        stage1: null,
        stage2: null,
        stage3: null,
        stage4: null,
    },
]
